import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'

const YAPI = false

export const findAwardPage = async (params: object) => {
  return await GET({
    url: YAPI ? 'http://yapi.bingex.com/mock/1082/activityCenter/inviteCourierActivity/findAwardPage'
      : '/activityCenter/inviteCourierActivity/findAwardPage',
    params,
    showError: false
  })
}
